import { ArrowLeft, UserIconFilled } from '@/components/icons'
import { Match, Team } from '@/types'

export type HistoryMatchProps = {
  match: Match
  index: number
  playerId: number
  opponentTeam: Team | undefined
  playerTeam: Team | undefined
  preMatchRating: number | undefined
  ratingImpact: number | undefined
}

export const HistoryMatch = ({ index, opponentTeam, playerTeam, ratingImpact, preMatchRating }: HistoryMatchProps) => {
  const renderMatchScores = () => {
    return (
      <div className="flex flex-col justify-end divide-y">
        <div className="flex flex-row gap-x-1">
          <div className="w-4 h-8 flex flex-col items-center justify-center">
            <p className={`text-navy-900 font-semibold ${playerTeam?.winner ? '' : 'text-opacity-50'}`}>
              {playerTeam?.game1}
            </p>
          </div>
          {playerTeam?.game2 !== -1 && (
            <div className="w-4 h-8 flex flex-col items-center justify-center">
              <p className={`text-navy-900 font-semibold ${playerTeam?.winner ? '' : 'text-opacity-50'}`}>
                {playerTeam?.game2}
              </p>
            </div>
          )}
          {playerTeam?.game3 !== -1 && (
            <div className="w-4 h-8 flex flex-col items-center justify-center">
              <p className={`text-navy-900 font-semibold ${playerTeam?.winner ? '' : 'text-opacity-50'}`}>
                {playerTeam?.game3}
              </p>
            </div>
          )}
          {playerTeam?.game4 !== -1 && (
            <div className="w-4 h-8 flex flex-col items-center justify-center">
              <p className={`text-navy-900 font-semibold ${playerTeam?.winner ? '' : 'text-opacity-50'}`}>
                {playerTeam?.game4}
              </p>
            </div>
          )}
          {playerTeam?.game5 !== -1 && (
            <div className="w-4 h-8 flex flex-col items-center justify-center">
              <p className={`text-navy-900 font-semibold ${playerTeam?.winner ? '' : 'text-opacity-50'}`}>
                {playerTeam?.game5}
              </p>
            </div>
          )}
          <div className={`w-4 h-8 flex flex-col items-center justify-center ${playerTeam?.winner ? '' : 'opacity-0'}`}>
            <ArrowLeft />
          </div>
        </div>

        <div className="flex flex-row gap-x-1">
          <div className="w-4 h-8 flex flex-col items-center justify-center">
            <p className={`text-navy-900 font-semibold ${opponentTeam?.winner ? '' : 'text-opacity-50'}`}>
              {opponentTeam?.game1}
            </p>
          </div>
          {opponentTeam?.game2 !== -1 && (
            <div className="w-4 h-8 flex flex-col items-center justify-center">
              <p className={`text-navy-900 font-semibold ${opponentTeam?.winner ? '' : 'text-opacity-50'}`}>
                {opponentTeam?.game2}
              </p>
            </div>
          )}
          {opponentTeam?.game3 !== -1 && (
            <div className="w-4 h-8 flex flex-col items-center justify-center">
              <p className={`text-navy-900 font-semibold ${opponentTeam?.winner ? '' : 'text-opacity-50'}`}>
                {opponentTeam?.game3}
              </p>
            </div>
          )}
          {opponentTeam?.game4 !== -1 && (
            <div className="w-4 h-8 flex flex-col items-center justify-center">
              <p className={`text-navy-900 font-semibold ${opponentTeam?.winner ? '' : 'text-opacity-50'}`}>
                {opponentTeam?.game4}
              </p>
            </div>
          )}
          {opponentTeam?.game5 !== -1 && (
            <div className="w-4 h-8 flex flex-col items-center justify-center">
              <p className={`text-navy-900 font-semibold ${opponentTeam?.winner ? '' : 'text-opacity-50'}`}>
                {opponentTeam?.game5}
              </p>
            </div>
          )}
          <div
            className={`w-4 h-8 flex flex-col items-center justify-center ${opponentTeam?.winner ? '' : 'opacity-0'}`}
          >
            <ArrowLeft />
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className={`w-full h-fit flex flex-row gap-x-4 p-4 items-center`}>
      <div className="bg-navy-900 bg-opacity-10 rounded-full">
        <div className="w-4 h-4 relative">
          <div className="absolute w-full h-full flex justify-center items-center">
            <p className="text-[11px] font-medium text-navy-900">{index + 1}</p>
          </div>
        </div>
      </div>

      <div className="w-full flex flex-row items-center justify-between">
        <div className="flex flex-col gap-y-2">
          <div className="flex flex-row items-center gap-x-2 w-20">
            <div className="rounded-full">
              <div className="w-4 h-4 relative">
                <div className="absolute w-full h-full">
                  {opponentTeam?.player1.imageUrl ? (
                    <img src={opponentTeam?.player1.imageUrl} alt="" className="w-4 h-4 rounded-full" />
                  ) : (
                    <UserIconFilled className="w-4 h-4" />
                  )}
                </div>
              </div>
            </div>
            <p className="text-darkBlue text-xs font-medium truncate">{opponentTeam?.player1.fullName}</p>
          </div>
          {opponentTeam?.player2 && (
            <div className="flex flex-row items-center gap-x-2 w-20">
              <div className="rounded-full">
                <div className="w-4 h-4 relative">
                  <div className="absolute w-full h-full">
                    {opponentTeam?.player2.imageUrl ? (
                      <img src={opponentTeam?.player2.imageUrl} alt="" className="w-4 h-4 rounded-full" />
                    ) : (
                      <UserIconFilled className="w-4 h-4" />
                    )}
                  </div>
                </div>
              </div>
              <p className="text-darkBlue text-xs font-medium truncate">{opponentTeam.player2.fullName}</p>
            </div>
          )}
        </div>

        {renderMatchScores()}
      </div>

      <div
        className={`w-12 h-[42px] pt-[2px] px-2 pb-1 rounded-lg ${
          playerTeam?.winner
            ? 'bg-primary text-primary'
            : opponentTeam?.winner
              ? 'text-primary bg-primary'
              : 'bg-navy-900 bg-opacity-10 text-navy-900 text-opacity-50'
        } bg-opacity-10  flex flex-col items-end`}
      >
        <p className="text-sm font-semibold">{preMatchRating ? preMatchRating.toFixed(2) : '0.00'}</p>
        <p className="text-[11px] font-medium">
          {Number(ratingImpact) > 0 ? '+' : ''}
          {ratingImpact ? ratingImpact.toFixed(2) : 0}
        </p>
      </div>
    </div>
  )
}

export default HistoryMatch
